import { render } from "./Barchart3.vue?vue&type=template&id=126105a8&scoped=true"
import script from "./Barchart3.vue?vue&type=script&lang=js"
export * from "./Barchart3.vue?vue&type=script&lang=js"

import "./Barchart3.vue?vue&type=style&index=0&id=126105a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126105a8"]])

export default __exports__